export default {
  type: "form-option",
  style: "",
  data: {
    label: "New Option",
    options: [
      {
        label: "Option 1",
      },
      {
        label: "Option 2",
      },
      {
        label: "Option 3",
      }
    ],
  },
  children: [],
};
